<template>
  <v-dialog
    v-model="isOpen"
    @click:outside="close"
    max-width="600px"
    content-class="rounded-xl"
    :persistent="exporterLoading"
    :overlay-opacity="0.9"
  >
    <v-card class="pa-8">
      <div class="py-16 d-flex justify-center" v-if="loading">
        <v-progress-circular
          indeterminate
          size="45"
          width="4"
          color="primary"
        />
      </div>
      <component
        v-else
        :is="currentExporter"
        @close="close"
        @loading="exporterLoading = $event"
      ></component>
    </v-card>
  </v-dialog>
</template>

<script>
const exporterComponents = {};
const context = require.context("./modules", true, /\.vue$/);

context.keys().forEach((key) => {
  const componentName = key.replace(/^\.\/(.*)\.\w+$/, "$1");
  exporterComponents[componentName] = () => context(key);
});

export default {
  data: () => ({
    isOpen: false,
    loading: true,
    exporterLoading: false,
    currentExporter: null,
  }),
  methods: {
    async loadExporter(exporterName) {
      try {
        this.loading = true;
        if (exporterComponents[exporterName]) {
          const exporter = await exporterComponents[exporterName]();
          this.currentExporter = exporter.default;
        } else {
          console.log(exporterComponents, exporterName);
          throw new Error({ code: 404, message: "Documento não encontrado" });
        }
      } catch (e) {
        this.currentExporter = () => import("./modules/_404.vue");
      } finally {
        this.loading = false;
      }
    },
    run(data) {
      this.isOpen = true;
      this.loadExporter(data.executer);
    },
    close() {
      if (this.exporterLoading) return;
      this.isOpen = false;
      this.loading = true;
      this.currentExporter = null;
    },
  },
  mounted() {
    this.$root.$on("executer:run", this.run);
  },
};
</script>

<style></style>
